export {default as NaturalTime} from './natural-time-view';
